<template>
  <div class="mod-content container" :class="{ loading: loading, 'mod-article': !menus.length }">
    <a-breadcrumb class="cell-header" separator=">">
      <a-breadcrumb-item>
        <a href="/" title="主页">主页</a>
      </a-breadcrumb-item>
      <a-breadcrumb-item v-if="title">
        {{ title }}
      </a-breadcrumb-item>
      <a-breadcrumb-item>{{ content.title }}</a-breadcrumb-item>
    </a-breadcrumb>
    <div class="loading" v-if="loading">
      <a-spin size="large"></a-spin>
    </div>
    <div v-else class="cell-body clearfix">
      <div class="l8-side-menu" v-if="menus.length && content.key">
        <side-menu
          :menus="menus"
          :active="content.key"
          :title="content.title"
        >
        </side-menu>
      </div>
      <div class="content" :data-cms="content._moduleId">
        <div class="content-header">
          <h3 class="title">{{ content.title }}</h3>
          <p class="time" v-if="content.time">{{ content.time | dateFilter('YYYY-MM-DD HH:mm:ss') }}</p>
        </div>
        <div class="content-body" v-html="content.content"></div>
      </div>
    </div>
  </div>
</template>

<script>
import './index'
import { dateFilter } from '@/filters/util'

export default {
  data () {
    return {
      title: '',
      menus: [],
      content: {},
      loading: false,
      match: null
    }
  },
  watch: {
    $route: {
      handler () {
        this.init()
      },
      deep: true
    }
  },
  created () {
    this.init()
  },
  methods: {
    async init () {
      const { params, matched } = this.$route
      const { id } = params
      this.loading = true
      this.fetch(id)

      if (!this.match || this.match !== matched[0].path) {
        this.match = matched[0].path
        try {
          const { menus } = await window.__MICRO_ROOT__?.cms.getPageData()

          if (menus) {
            this.title = menus.title || ''
            this.menus = menus.menus || []
          }
        } catch (err) {
          console.error(err)
        }
      }
    },
    async fetch (id) {
      try {
        const data = await window.__MICRO_ROOT__.cms.fetchPageData(id)

        if (data) {
          this.content = data.content
          this.loading = false
        } else {
          this.$router.replace('/404')
        }
      } catch (err) {
        this.$router.replace('/404')
      }
    }
  },
  filters: {
    dateFilter
  }
}
</script>
